import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiAffiliatesList, apiAffiliatesView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/affiliates/getData', async datas => {
    const { data } = await apiAffiliatesList(datas)
    return data
})

export const getView = createAsyncThunk('admin/affiliates/getView', async id => {
    if (!id) return viewData
    const { data } = await apiAffiliatesView(id)
    data.phone = data.phone ?? ''
    data.logo = ''
    data.images = []
    data.image_remove = []
    return data
})

const viewData = {
    business_name: '',
    secondary_name: '',
    secondary_phone: '',
    primary_name: '',
    primary_phone: '',
    address: '',
    phone: '',
    types: '',
    affiliate_other: '',
    logo: '',
    images: [],
    image_remove: [],
    notes: '',
    start: '',
    delivery_instructions: '',
}

export const affiliatesSlice = createSlice({
    name: 'admin/affiliates',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = affiliatesSlice.actions

export default affiliatesSlice.reducer
